class Vizpan {
    /**
     * Builds the main Vizpan object for given canvas id
     * @param canvasElement The id string of a canvas element
     */
    constructor(canvasElement) {
        this.canvasElement = canvasElement;
        this.scale = 1;
        this.translateX = 0;
        this.translateY = 1;
        // Fabric.js setup and settings
        this.fabricCanvas = new fabric.Canvas(canvasElement, {
            selection: false,
            hoverCursor: 'default'
        });
        // EasyPZ setup
        const outer = this;
        // tslint:disable-next-line: no-unused-expression
        new EasyPZ(document.body, 
        // The Pan and Zoom function
        (transform) => {
            outer.translateX = transform.translateX;
            outer.translateY = transform.translateY;
            outer.scale = transform.scale;
            for (const comp of outer.components) {
                comp.updateFabricObject();
            }
            outer.fabricCanvas.renderAll();
        }, 
        // EasyPZ settings
        {
            minScale: 0.1,
            maxScale: 5,
            bounds: {
                top: -this.fabricCanvas.getHeight() / 2,
                bottom: this.fabricCanvas.getHeight() / 2,
                right: this.fabricCanvas.getWidth() / 2,
                left: -this.fabricCanvas.getWidth() / 2
            }
        });
        this.components = [];
    }
    /**
     * Inserts a component into the canvas
     * @param component
     */
    add(component) {
        component.vizpan = this;
        component.createFabricObject();
        this.components.push(component);
    }
}
